import { render, staticRenderFns } from "./prepareTransInfo.vue?vue&type=template&id=8c956fec"
import script from "./prepareTransInfo.vue?vue&type=script&lang=js"
export * from "./prepareTransInfo.vue?vue&type=script&lang=js"
import style0 from "./prepareTransInfo.vue?vue&type=style&index=0&id=8c956fec&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports